import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/lost-found/get-lost-found-outcome-forms';

  return API({ endpoint });
}
